module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event-log text-dark pad-10"
  }, [_c('h2', {
    staticClass: "marg-10-bottom event-log__header"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['latest_activity']))]), _vm._v(" "), _c('div', {
    staticClass: "el-items"
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": "#f6f9fc"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.logsFormatted), function(activity) {
    return _c('div', {
      staticClass: "el-items__item marg-10-bottom"
    }, [_c('div', {
      staticClass: "el-info"
    }, [_c('div', {
      staticClass: "el-info-right"
    }, [_c('div', {
      staticClass: "el-info__headline"
    }, [_c('p', [_c('b', [_vm._v(_vm._s(activity.by))])]), _vm._v(" "), _c('p', {
      staticClass: "text-grey hint--top-left",
      attrs: {
        "aria-label": activity.vFormattedDate
      }
    }, [_vm._v("\n              " + _vm._s(activity.vDuration) + " " + _vm._s(_vm.i18n[_vm.locale].ago))])]), _vm._v(" "), (activity.changes) ? _c('div', {
      staticClass: "el-items__item__changes"
    }, _vm._l((activity.vHumanizedChanges), function(txt) {
      return _c('p', {
        domProps: {
          "innerHTML": _vm._s(txt)
        }
      })
    }), 0) : _c('div', {
      staticClass: "el-items__item__changes"
    }, [_c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['created']))])])])])])
  }), _vm._v(" "), (!_vm.isLoading && _vm.sortedLogs.length < 1) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['no_changes']) + "\n    ")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cd76fcaa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Log/EventChanges.vue
// module id = 2127
// module chunks = 1